(ns ui.components.menu.view
  (:require
   [ui.util :as uu]))

;; the fixed tw2-class-names until we get styles.json from zapkit-components.
;; Transcribed from zapkit-components/src/components/Menu/Menu.styles.ts and
;; Menu.tsx, as a faithful mirror: when the real styles.json lands, rebinding
;; `styles` to a generated `zapkit-styles/menu` should be an overwrite, not a
;; reconciliation. Unlike the checkbox this needs no DOM-driven overrides —
;; upstream's menu item is a single element, same as ours.
(def temp-styles
  {:menu-item
   {:base
    "tw2-flex tw2-items-center tw2-w-full tw2-px-nav-item-px tw2-py-nav-item-py tw2-text-label-md tw2-font-sans tw2-rounded-nav-item tw2-cursor-pointer tw2-text-left tw2-transition-all tw2-duration-150 tw2-ease-in-out focus-visible:tw2-outline-none"
    :state
    {:default
     "tw2-bg-nav-item-bg-default tw2-text-nav-item-text-default hover:tw2-bg-nav-item-bg-hover active:tw2-bg-nav-item-bg-pressed focus-visible:tw2-ring-2 focus-visible:tw2-ring-nav-item-focus-ring focus-visible:tw2-outline-none"
     :active
     "tw2-bg-nav-item-bg-active tw2-text-nav-item-text-active tw2-cursor-default"
     :disabled
     "tw2-bg-nav-item-bg-disabled tw2-text-nav-item-text-disabled tw2-cursor-not-allowed tw2-opacity-50 tw2-pointer-events-none"}}
   :label
   {:base "tw2-flex-1 tw2-min-w-0 tw2-whitespace-normal tw2-break-words"}
   :icon
   {:base "tw2-shrink-0"}
   :menu
   {:base "tw2-flex tw2-flex-col"}})

(defn- item-state
  [{:keys [active disabled]}]
  (cond
    disabled :disabled
    active :active
    :else :default))

(defn- item-class
  [state class]
  (let [styles temp-styles]
    (uu/cm
     (get-in styles [:menu-item :base])
     (get-in styles [:menu-item :state state])
     class)))

(defn- menu-item-content
  [{:keys [label start-icon end-icon]}]
  (let [styles temp-styles]
    [:<>
     (when start-icon
       [:span {:class (get-in styles [:icon :base])
               :aria-hidden true}
        start-icon])
     [:span {:class (get-in styles [:label :base])}
      label]
     (when end-icon
       [:span {:class (get-in styles [:icon :base])
               :aria-hidden true}
        end-icon])]))

(defn- item-view
  [{:keys [id href active disabled on-click class] :as item}]
  (let [state (item-state item)
        classes (item-class state class)
        click-handler (fn [e]
                        (when (fn? on-click)
                          (on-click e)))]
    (cond
      active
      [:button {:key id
                :type "button"
                :class classes
                :on-click click-handler
                :aria-current "page"
                :role "menuitem"}
       [menu-item-content item]]

      (and href (not disabled))
      [:a {:key id
           :href href
           :class classes
           :on-click click-handler
           :role "menuitem"}
       [menu-item-content item]]

      :else
      [:button {:key id
                :type "button"
                :class classes
                :on-click click-handler
                :disabled (boolean disabled)
                :aria-disabled (boolean disabled)
                :role "menuitem"}
       [menu-item-content item]])))

(defn view
  [{:keys [items class class-name aria-label]
    :or {aria-label "Navigation menu"}
    :as props}]
  (let [nav-props (-> props
                      (dissoc :items :class :class-name :aria-label)
                      (assoc :class (uu/cm (get-in temp-styles [:menu :base])
                                           class
                                           class-name)
                             :aria-label aria-label
                             :role "navigation"))]
    [:nav nav-props
     [:div {:class (get-in temp-styles [:menu :base])
            :role "menu"
            :aria-label "Menu items"}
      (doall
       (for [item items]
         ^{:key (:id item)}
         [item-view item]))]]))
